// src/types/common.ts

import { InvoiceDetailSerializer } from "./invoice"

export interface PaginationType {
  count: number
  currentPage: number
  totalPages: number
  pageSize: number
  hasNext: boolean
  hasPrevious: boolean
  nextPage: number | null
  previousPage: number | null
}

export const initialPaginationInfo: PaginationType = {
  count: 0,
  currentPage: 1,
  totalPages: 1,
  pageSize: 40,
  hasNext: false,
  hasPrevious: false,
  nextPage: null,
  previousPage: null,
}

export interface CommonResponse {
  message?: string
  errors?: {}
  result?: boolean
}

export interface CommonTResponse<T> {
  message?: string
  errors?: {}
  result?: T
  results?: T[]
  invoice?: InvoiceDetailSerializer
  pagination?: PaginationType
}

// export interface CommonTResponse<T> {
//   code?: string
//   message?: string
//   errors?: {}
//   columns?: string[]
//   result?: T[]
// }

// export interface CommonTResponse<T> {
//   code?: string
//   message?: string
//   errors?: {}
//   columns?: string[]
//   result?: T[]
//   results?: T[]
// }

export interface CommonReferenceResponse {
  message?: string
  errors?: {}
  columns: string[]
  results: Array<(number | string)[]>
}

export interface CommonExsistSerializer {
  isExist: boolean
}

export interface commonPageResult<T> {
  results: T[]
  pagination: PaginationType
}

export interface CommonPageTResponse<T> {
  code: string
  message?: string
  errors?: {}
  result: commonPageResult<T>
}
